import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MatrixFeature {
  feature: string;
  speed: boolean;
  strength: boolean;
  fitness: boolean;
  kids: boolean;
}

const ComparisonMatrix = () => {
  const features: MatrixFeature[] = [
    { feature: 'Personalized Training Plans', speed: true, strength: true, fitness: true, kids: true },
    { feature: 'Olympic-Level Coaching', speed: true, strength: true, fitness: false, kids: false },
    { feature: 'Performance Tracking', speed: true, strength: true, fitness: true, kids: true },
    { feature: 'Nutrition Guidance', speed: true, strength: true, fitness: true, kids: true },
    { feature: 'Injury Prevention Protocols', speed: true, strength: true, fitness: true, kids: true },
    { feature: 'Competition Preparation', speed: true, strength: true, fitness: false, kids: false },
    { feature: 'Age-Specific Development', speed: false, strength: false, fitness: false, kids: true },
    { feature: 'Flexible Scheduling', speed: true, strength: true, fitness: true, kids: true },
    { feature: 'Group Training Sessions', speed: true, strength: true, fitness: true, kids: true },
    { feature: 'One-on-One Coaching', speed: true, strength: true, fitness: true, kids: false },
  ];

  const programs = [
    { name: 'Speed Training', key: 'speed' as const, color: 'text-accent' },
    { name: 'Strength', key: 'strength' as const, color: 'text-championship-red' },
    { name: 'General Fitness', key: 'fitness' as const, color: 'text-success' },
    { name: 'Kids Program', key: 'kids' as const, color: 'text-gold' },
  ];

  return (
    <div className="bg-card rounded-lg shadow-card p-6 overflow-x-auto">
      <h3 className="text-xl font-heading font-bold text-primary mb-6">Program Comparison Matrix</h3>
      
      <table className="w-full min-w-[600px]">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-4 px-4 text-sm font-heading font-bold text-primary">Features</th>
            {programs.map((program) => (
              <th key={program.key} className="text-center py-4 px-4">
                <span className={`text-sm font-heading font-bold ${program.color}`}>{program.name}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {features.map((feature, index) => (
            <tr key={index} className="border-b border-border hover:bg-muted transition-colors duration-300">
              <td className="py-4 px-4 text-sm text-text-secondary">{feature.feature}</td>
              {programs.map((program) => (
                <td key={program.key} className="text-center py-4 px-4">
                  {feature[program.key] ? (
                    <Icon name="CheckCircleIcon" size={20} variant="solid" className="text-success inline-block" />
                  ) : (
                    <Icon name="XCircleIcon" size={20} variant="solid" className="text-text-secondary opacity-30 inline-block" />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ComparisonMatrix;